import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { safeExtractFromObject } from '../helpers/helpers';
import BorderlessButton from '../common/buttons/BorderlessButton';
import colors from '../constants/Colors';

export default function TimeCardDatePickerButton({
  arrowDirection,
  onClick,
  visible,
  disabled,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;
  const icon = arrowDirection === 'left'
    ? <LeftOutlined className="date-range-picker-icon" />
    : <RightOutlined className="date-range-picker-icon" />;

  if (!visible) return <Col style={{width:30}} />
  return (
    <Col>
      <Row justify='center' align='middle'>
        <BorderlessButton
          style={{ width: 30,
            backgroundColor: hasRedesign ? colors.BLUE_700 : colors.ONTRACCR_DARK_YELLOW,
            padding:0,
            borderRadius:4,
            opacity: disabled ? 0.25 : 1,
          }}
          iconNode={icon}
          onClick={onClick}
          disabled={disabled}
        />
      </Row>
    </Col>
  );
}

TimeCardDatePickerButton.propTypes = {
  arrowDirection: PropTypes.oneOf(['left', 'right']).isRequired,
  onClick: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

TimeCardDatePickerButton.defaultProps = {
  disabled: false,
};
